import { HtmlParser } from '@calendly/html-parser';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import React from 'react';
import { StepThree } from 'features/meeting_intelligence';
import { useHasSpotlight } from 'features/meetings/hooks';
import type { Meeting } from 'features/meetings/types';
import { useMeetingSummaryData } from './useMeetingSummaryData';
const containerCss = "c144gbtt";
const headerCss = "hhlt4mz";
const titleCss = "twpmob6";
const titleTruncateCss = "t1pl65mj";
const titleCancelledCss = "tqahmye";
const subtitleCss = "s105vn3w";
const subtitleTextCss = "sq0g36t";
interface MeetingSummaryProps {
  event: Meeting;
  packageName?: string | null;
  className?: string;
  children?: React.ReactNode;
}

/**
 * Renders the title and participant summary section of a meeting card.
 *
 * Displays the event name, participant summary line from `getParticipantText`, and an
 * optional package name. Applies a strikethrough to the title when the
 * meeting is cancelled. Integrates with the Meeting Intelligence onboarding
 * tour step-three spotlight on desktop.
 *
 * @param event - The meeting whose name and participant data are displayed
 * @param packageName - Optional package booking name rendered below the title
 * @param className - Optional additional CSS class for the container
 * @param children - Optional content rendered after the summary (e.g. warning badges)
 */
export const MeetingSummary = ({
  event,
  packageName,
  className,
  children
}: MeetingSummaryProps) => {
  const hasSpotlight = useHasSpotlight(event.key);
  const {
    cancelled,
    isGroup,
    participantText,
    showStepThree,
    isPhone
  } = useMeetingSummaryData(event);
  return <div className={classNames(containerCss, className)}>
      <div className={headerCss}>
        <span className={classNames(titleCss, cancelled && titleCancelledCss)}>
          <TitleText level={3} size="medium" color={cancelled ? colorTextSecondary : undefined}>
            <span className={titleTruncateCss}>{event.name}</span>
          </TitleText>
        </span>
        <span className={subtitleCss}>
          {showStepThree && hasSpotlight && !isPhone && <StepThree isVisible={hasSpotlight} />}
          <span className={subtitleTextCss}>
            {participantText && <FullStoryMask>
                <BodyText inline size="medium">
                  {HtmlParser(participantText)}
                </BodyText>
              </FullStoryMask>}
          </span>
        </span>
      </div>
      {packageName && !isGroup && <BodyText color="muted" size="small">
          {packageName}
        </BodyText>}
      {children}
    </div>;
};

require("./MeetingSummary.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingSummary.tsx");